import React, { useEffect, useMemo, useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Card, CardBody, Col, Container, Row, Button, Label, CardText, CardTitle, ButtonGroup, Input, Badge } from 'reactstrap';
import notify from '../../../custom/helpers/Notify';
import '../../../pages/Tables/datatables.scss';
import { ActionButtons } from '../../../custom/components/ActionButtons';
import { ConfirmDialog } from '../../../custom/components/ConfirmDialog';
import { pageState, lastAPIActionTimeState, pageWebsocketsEnabledState, themeTypeState, leftSidebarTypeState } from '../../../state/GlobalState';
import { HasPermission } from '../../../custom/helpers/HasPermission';
import { DynamicModal } from '../../../custom/components/DynamicModal';
import { ImportModal } from '../../../custom/components/ImportModal';
import { BibTagModal } from '../../../custom/components/BibTagModal';
import { GoalModal } from '../../../custom/components/GoalModal';
import { NoteModal } from '../../../custom/components/NoteModal';
import { FaqModal } from '../../../custom/components/FaqModal';
import { RaceKitFilterModal } from '../../../custom/components/RaceKitFilterModal';
import { getActiveFaqRequest } from '../../../api/controller/EventController';
import { cloneDeep, get,set } from 'lodash';
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import SweetAlert from 'react-bootstrap-sweetalert';
import { getDataListRequest, updateDataRequest, deleteDataRequest, isDisplayedRequest, getRaceListRequest, getTeeListRequest, exportDataListRequest, teeIssueDataRequest, resetDataRequest, importDataRequest, getClubsForActiveEventRequest, bulkIssueByClubRequest, getRaceKitsByClubRequest, getNationalityListRequest, exportClubKitsRequest } from '../../../api/controller/RaceKitController'; // CHANGE (controller name)
import { formModes, filtersDefault, modalConfigDefault, raceKitDataStructureState as dataStructureState, raceKitListState as dataListState, raceKitRaceState, raceKitTeeState, clubsForActiveEventState, bulkIssueModalState, viewClubKitsModalState, raceKitNationalityState, raceKitFiltersDefault, raceKitMatchesFilters, countActiveRaceKitFilters, raceKitFiltersToPayload } from './state'; // CHANGE (dataList & structure stateName)
import { Loader } from '../../../custom/components/Loader';
import echo from '../../../api/core/echo';
import { handleSocket, handleGridSocket } from '../../../custom/helpers/HandleSocket';
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { handleResponse } from '../../../custom/helpers/HandleResponse';
import SelectEditor from "../../../custom/components/grid/SelectEditor"
import DefaultEditor from "../../../custom/components/grid/DefaultEditor"
import MaskEditor from "../../../custom/components/grid/MaskEditor"
import DateTimeEditor from "../../../custom/components/grid/DateTimeEditor"
import RadioEditor from "../../../custom/components/grid/RadioEditor"
import CheckboxEditor from "../../../custom/components/grid/CheckboxEditor"
import SwitchEditor from "../../../custom/components/grid/SwitchEditor"
import moment from "moment";
import useBreakpoint from '../../../custom/components/hooks/useBreakpoint';

const RaceKits = () => {
  
  const model = 'Race Kit' // CHANGE
  const models = 'Race Kits' // CHANGE
  
  // GET & SET SELECTS
  const selects = [
    { model: 'Race', getFn: getRaceListRequest, setFn: useSetRecoilState(raceKitRaceState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
		{ model: 'Tee', getFn: getTeeListRequest, setFn: useSetRecoilState(raceKitTeeState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
    { model: 'Nationality', getFn: getNationalityListRequest, setFn: useSetRecoilState(raceKitNationalityState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
		
    // { model: 'ModelName', getFn: getModelListRequest, setFn: useSetRecoilState(modelState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
  ]

  const [partialUpdating, setPartialUpdating] = useState(false)

  const defaultColDef = {
    sortable: true,
    editable: true,
    valueSetter: async(e) => {
      setPartialUpdating(true)
      let tempRow = { id: e.data.id }
      let s = ['select','multiselect']
      dataStructure.filter(i=>i.table?.editable).forEach((input) => {        
        let v = e.newValue
        if((e.column.colDef?.cellEditorParams?.fieldName || e.column.colId) !== getFN(input)){
          if(Array.isArray(e.data[getFN(input)])){
            v = e.data[getFN(input)].map(i=>s.includes(input.type) ? (i[input.subFields?.value || "id"] || i) : i)
          } else if(s.includes(input.type)){
            v = e.data[getFN(input)][input.subFields?.value || "id"] || e.data[getFN(input)]
          } else if(input.type === 'datepicker' && input.table?.postDateFormat){
            v = moment(e.data[getFN(input)]).format(input.table?.postDateFormat)
          } else {
            v = e.data[getFN(input)]
          }
        } else {
          if(input.type === 'datepicker' && input.table?.postDateFormat){
            v = moment(v).format(input.table?.postDateFormat)
          }
        }
        tempRow = {...tempRow, [getPN(input)]: v }
      })
      const response = await updateDataRequest({...tempRow})
      handleResponse(response)
      setPartialUpdating(false)
    },
  }
  
  const [ovf, _setOvf] = useState(false);
  const ovfRef = useRef(ovf);
  const setOvf = data => {
    ovfRef.current = data;
    _setOvf(data);
  }
  const [dataList, setDataList] = useRecoilState(dataListState);
  // eslint-disable-next-line
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [gridApi, _setGridApi] = useState(null);
  const gridApiRef = useRef(gridApi)
  const setGridApi = data => {
    gridApiRef.current = data;
    _setGridApi(data)
  }
  const [pageWebsocketsEnabled, setPageWebsocketsEnabled] = useRecoilState(pageWebsocketsEnabledState)
  const setPage = useSetRecoilState(pageState)
  const [lastAPIActionTime, setLastAPIActionTime] = useRecoilState(lastAPIActionTimeState)
  const [tableLoading, setTableLoading] = useState(true)
  const themeType = useRecoilValue(themeTypeState)
  const [mobileSearchFilter, setMobileSearchFilter] = useState('')	
  const [searchValue, setSearchValue] = useState('')	
  const searchValueRef = useRef(searchValue)
	
  const [confirmModalVisible, setConfirmModalVisible] = useState(false)
  const [confirmID, setConfirmID] = useState(null);
  const [confirmParams, setConfirmParams] = useState({});
  const [confirmConfig, setConfirmConfig] = useState({ fn: null, title: null, body: null });
  const [cuModalConfig, _setCUModalConfig] = useState({visible: false, header: model, type: null, typeKey: null, data: {}, ...modalConfigDefault})
  const cuModalConfigRef = useRef(cuModalConfig)
  const setCUModalConfig = data => {
    cuModalConfigRef.current = data;
    _setCUModalConfig(data)
  }
  const [importModalVisible, setImportModalVisible] = useState(false)
  const [bibTagModalVisible, setBibTagModalVisible] = useState(false)
  const [goalModalVisible, setGoalModalVisible] = useState(false)
  const [selectedRaceKit, setSelectedRaceKit] = useState(null)
  const [actionsDisabled, setActionsDisabled] = useState(true)
  // Separate from actionsDisabled: that one gates the page toolbar, and a club
  // download in progress should not grey out buttons behind the modal.
  const [clubExportDisabled, setClubExportDisabled] = useState(false)
  const [faq, setFaq] = useState({ loading: true, content: '', eventName: '' })
  const [faqModalVisible, setFaqModalVisible] = useState(false)
  // The race list is already loaded for the form's Race select; the filter
  // modal reads the same options rather than fetching its own.
  const raceKitRaces = useRecoilValue(raceKitRaceState)
  const [kitFilters, setKitFilters] = useState(raceKitFiltersDefault)
  const [filterModalVisible, setFilterModalVisible] = useState(false)
  const [primaryChannel, setPrimaryChannel] = useState(null)
  const [filters, setFilters] = useState(filtersDefault)
  const dataStructure = useRecoilValue(dataStructureState)
  const [selectedRow, setSelectedRow] = useState(null)
  
  // Bulk issue state
  const [clubsForActiveEvent, setClubsForActiveEvent] = useRecoilState(clubsForActiveEventState)
  const [bulkIssueModal, setBulkIssueModal] = useRecoilState(bulkIssueModalState)
  const [viewClubKitsModal, setViewClubKitsModal] = useRecoilState(viewClubKitsModalState)
  
  // SweetAlert confirmation state
  const [showBulkIssueConfirm, setShowBulkIssueConfirm] = useState(false)
  
  const breakPoint = useBreakpoint()
  const [xsFData, _setXsFData] = useState([])
  const xsFDataRef = useRef(xsFData)
  const setXsFData = data => {
    xsFDataRef.current = data;
    _setXsFData(data)
  }
  const [xsPageSize] = useState(10)
  const [xsCurrentPage, setXsCurrentPage] = useState(1)
  const [xsMaxPage, setXsMaxPage] = useState(1)

  const leftSidebarType = useRecoilValue(leftSidebarTypeState)

  useEffect(() => {
    if(gridApi){
      gridApi.sizeColumnsToFit()
    }
    // eslint-disable-next-line
  }, [leftSidebarType])

  useEffect(() => {
    setPage((models.charAt(0).toLowerCase() + models.slice(1)).split(" ").join(""))
    setPageWebsocketsEnabled(process.env.REACT_APP_WEBSOCKETS_ENABLED === 'true')
  }, [setPage, setPageWebsocketsEnabled])

  useEffect(() => {
    async function fetchData(filter){
      setTableLoading(true)
      setDataList([])
      const response = await getDataListRequest(filter);
      if(response && response.Status !== 'error'){
        setDataList(response.data)
        response.ovf ? setOvf(true) : setOvf(false)
      } else {
        notify({ status: 'error', message: response.Message })
      }	
      searchValueRef.current = searchValue;	
      setTableLoading(false)
    }
    let fetch = true
    let postData = {}
    if(filters.length > 0){
      filters.forEach((filter)=>{
        fetch = filter.value.length === 0 && filter.required ? false : fetch
        if(filter.value){
          set(postData, filter.name || filter.label.replace(/ /g, ''), filter.type === "select" ? filter.value.value : filter.value)
        }
      })	
    }	
    if(ovf){	
      set(postData, 'SearchQuery', searchValue)
    }	
    if(pageWebsocketsEnabled){
      if(fetch){	
        fetchData(postData)	
      }
      const channelFilters = Object.keys(postData).filter((k)=>k !== "SearchQuery").length > 0 ? "." + Object.keys(postData).filter((k)=>k !== "SearchQuery").map((val)=>(postData[val].toString())).join(".") : ""
      const channelToSub = `${model.replace(/ /g, '')}-Primary${channelFilters}`
      if(primaryChannel !== channelToSub){
        if(primaryChannel){
          echo.leave(primaryChannel)
        }
        setPrimaryChannel(channelToSub)
        echo.private(channelToSub).listen(`.${model.replace(/ /g, '')}Events`, (data) => {
          if(gridApiRef.current){
            handleGridSocket(data, gridApiRef.current, setGridApi, (ovfRef.current ? isDisplayedRequest : false), searchValueRef.current)
          } else {
            handleSocket(xsFDataRef.current, data, setXsFData)
          }
          if(data.from !== echo.socketId() && cuModalConfigRef.current.visible === true && cuModalConfigRef.current.type === "Update" && parseInt(cuModalConfigRef.current.data.id) === parseInt(data.data.id) && data.event === "Updated"){
            setCUModalConfig({...cuModalConfigRef.current, expired: true})
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [lastAPIActionTime, filters, pageWebsocketsEnabled]);

  useEffect(() => {
    async function fetchSelectData(){
      setActionsDisabled(true)
      await Promise.all(selects.map(async(select)=>{
        if(! (select.persist && select.read?.length > 0)){
          const response = await select.getFn();
          const setFnRef = data => {
            select.ref.current = data
            select.setFn(data)
          }
          if(select.wsEnabled){
            echo.private(`${select.model}-Select`).listen(`.${select.model}Events`, (data) => {
              handleSocket(select.ref.current, data, setFnRef, select.keys || { label: "name", value: "id" })
            });
          }
          if(response && response.Status !== 'error'){	
            setFnRef({ ovf: response.ovf, data: (select.exactValue ? response.data : response.data?.map((val)=>({ label: val[select.keys.label || "name"], value: val[select.keys.value || "id"] }))) })	
          } else {	
            notify({ status: 'error', message: response.Message });	
          }
        }
      }))
      setActionsDisabled(false)
    }
    fetchSelectData();
    // Preloaded with the page rather than fetched when the modal opens: an
    // issuer reaches for this with a runner already at the desk.
    const fetchFaq = async () => {
      const response = await getActiveFaqRequest()
      if(response?.Status === 'success'){
        setFaq({ loading: false, content: response.Data?.Faq || '', eventName: response.Data?.EventName || '' })
      } else {
        setFaq((prev) => ({ ...prev, loading: false }))
      }
    }
    fetchFaq();
    return () => {
      setDataList([])
      if(pageWebsocketsEnabled){
        echo.leave(primaryChannel)
      }
      selects.filter(s=>!(s.persist && s.read?.length > 0)).forEach((s)=>{
        s.ref.current = []
        s.setFn([])
        if(s.wsEnabled){
          echo.leave(`${s.model}-Select`)
        }
      })
    }
    // eslint-disable-next-line
  }, [])
  
  // preBody is not carried over from the previous config the way header is —
  // it belongs to one row, so a modal opened without one must show none.
  const toggleCUModal = ({row={}, mode=null, modeKey=0, size=null, absoluteHeader=false, header=false, preBody=null, wizard=null}) => {
    setCUModalConfig({ ...cuModalConfig, visible: !cuModalConfig.visible, absoluteHeader: absoluteHeader, header: (header || cuModalConfig.header), preBody: preBody, type: typeof(mode) === 'string' ? mode : null, typeKey: modeKey, data: row, size: size || cuModalConfig.size, wizard: wizard !== null ? wizard : cuModalConfig.wizard })
  }

  const toggleConfirmModal = ({row={}, params={}, request=null, title=null, body=null}) => {
    setConfirmID(row ? row.id : null)
    setConfirmParams(params)
    setConfirmConfig({ fn: request, title: title, body: body })
    setConfirmModalVisible(! confirmModalVisible)
  }

  // Bulk issue functions
  const fetchClubsForActiveEvent = async () => {
    setClubsForActiveEvent(prev => ({ ...prev, loading: true, error: null }))
    try {
      const response = await getClubsForActiveEventRequest()
      if (response && response.Status !== 'error') {
        setClubsForActiveEvent({ data: response.data, loading: false, error: null })
      } else {
        setClubsForActiveEvent(prev => ({ ...prev, loading: false, error: response.Message }))
        notify({ status: 'error', message: response.Message })
      }
    } catch (error) {
      setClubsForActiveEvent(prev => ({ ...prev, loading: false, error: error.message }))
      notify({ status: 'error', message: 'Failed to fetch clubs' })
    }
  }

  const toggleBulkIssueModal = () => {
    setBulkIssueModal(prev => ({ ...prev, visible: !prev.visible }))
    if (!bulkIssueModal.visible) {
      fetchClubsForActiveEvent()
    }
  }

  const toggleViewClubKitsModal = () => {
    setViewClubKitsModal(prev => ({ ...prev, visible: !prev.visible }))
  }

  const fetchRaceKitsByClub = async (club) => {
    setViewClubKitsModal(prev => ({ ...prev, loading: true, error: null }))
    try {
      const response = await getRaceKitsByClubRequest({ Club: club })
      if (response && response.Status !== 'error') {
        setViewClubKitsModal(prev => ({ 
          ...prev, 
          selectedClub: club,
          raceKits: response.data,
          loading: false 
        }))
      } else {
        setViewClubKitsModal(prev => ({ 
          ...prev, 
          loading: false, 
          error: response.Message 
        }))
        notify({ status: 'error', message: response.Message })
      }
    } catch (error) {
      setViewClubKitsModal(prev => ({ 
        ...prev, 
        loading: false, 
        error: error.message 
      }))
      notify({ status: 'error', message: 'Failed to fetch race kits' })
    }
  }

  // Frontend search functionality
  const filteredRaceKits = useMemo(() => {
    if (!viewClubKitsModal.searchQuery.trim()) {
      return viewClubKitsModal.raceKits
    }
    
    const searchTerm = viewClubKitsModal.searchQuery.toLowerCase()
    return viewClubKitsModal.raceKits.filter(kit => 
      kit.name?.toLowerCase().includes(searchTerm) ||
      kit.id_number?.toLowerCase().includes(searchTerm) ||
      kit.bib_number?.toLowerCase().includes(searchTerm) ||
      kit.email?.toLowerCase().includes(searchTerm) ||
      kit.phone_number?.toLowerCase().includes(searchTerm) ||
      kit.race?.name?.toLowerCase().includes(searchTerm)
    )
  }, [viewClubKitsModal.raceKits, viewClubKitsModal.searchQuery])

  // Tee counts per size for the kits currently listed, so the desk knows what
  // to physically pull before a bulk issue. Follows the search filter, matching
  // the kit count shown above it. Ordered by tee_size_id — size names sort
  // wrongly ("2X-Large" lands before "Small").
  const clubTeeSummary = useMemo(() => {
    const bySize = new Map()
    let issued = 0
    filteredRaceKits.forEach(kit => {
      (kit.race_tees || []).forEach(raceTee => {
        const displayName = raceTee.tee?.display_name
        if(! displayName) return
        const parts = displayName.split(' | ')
        const size = parts.length > 1 ? parts[1] : displayName
        const quantity = parseInt(raceTee.quantity) || 0
        const row = bySize.get(size) || { size: size, quantity: 0, order: raceTee.tee?.tee_size_id ?? Number.MAX_SAFE_INTEGER }
        row.quantity += quantity
        bySize.set(size, row)
        if(kit.tee_issued) issued += quantity
      })
    })
    const rows = Array.from(bySize.values()).sort((a, b) => (a.order - b.order) || a.size.localeCompare(b.size))
    return { rows: rows, total: rows.reduce((sum, r) => sum + r.quantity, 0), issued: issued }
  }, [filteredRaceKits])

  const handleSearchChange = (e) => {
    setViewClubKitsModal(prev => ({ ...prev, searchQuery: e.target.value }))
  }

  const handleViewClubKits = (club) => {
    setViewClubKitsModal(prev => ({ ...prev, selectedClub: club }))
    fetchRaceKitsByClub(club)
    toggleViewClubKitsModal()
  }

  const handleBulkIssue = async () => {
    if (!bulkIssueModal.selectedClub || !bulkIssueModal.receiverName || !bulkIssueModal.receiverIdNumber || !bulkIssueModal.receiverPhone) {
      notify({ status: 'error', message: 'Please fill in all required fields' })
      return
    }

    // Show SweetAlert confirmation dialog
    setShowBulkIssueConfirm(true)
  }

  const handleBulkIssueConfirm = async () => {
    setShowBulkIssueConfirm(false)

    setBulkIssueModal(prev => ({ ...prev, loading: true }))
    try {
      const response = await bulkIssueByClubRequest({
        Club: bulkIssueModal.selectedClub,
        ReceiverName: bulkIssueModal.receiverName,
        ReceiverIdNumber: bulkIssueModal.receiverIdNumber,
        ReceiverPhone: bulkIssueModal.receiverPhone
      })

      if (response && response.Status !== 'error') {
        notify({ status: 'success', message: response.Message })
        setBulkIssueModal(prev => ({ 
          ...prev, 
          visible: false, 
          loading: false,
          selectedClub: null,
          receiverName: '',
          receiverIdNumber: '',
          receiverPhone: ''
        }))
        // Refresh the data
        // fetchData()
      } else {
        notify({ status: 'error', message: response.Message })
        setBulkIssueModal(prev => ({ ...prev, loading: false }))
      }
    } catch (error) {
      notify({ status: 'error', message: 'Failed to issue race kits' })
      setBulkIssueModal(prev => ({ ...prev, loading: false }))
    }
  }

  const getPN = (val) => {
    return val.name || val.label.replace(/ /g, '')
  }
  
  const getFN = (val) => {
    return val.field || val.label.replace(/ /g, '_').toLowerCase()
  }


  const actionListLocation = 'inline' // top
  const actionListType = 'menu' // buttons
  const xsActionListType = 'menu' // buttons
  const xsActions = useMemo(() => ([
    {
      label: 'Delete',
      permission: 'delete',
      icon: 'mdi mdi-delete d-block font-size-12',
      color: 'danger',
      fn: toggleConfirmModal,
      params: { request: deleteDataRequest }
    },
    {
      label: 'Reset',
      permission: 'reset',
      icon: 'mdi mdi-refresh d-block font-size-12',
      color: 'warning',
      fn: toggleConfirmModal,
      params: { request: resetDataRequest }
    },
    {
      label: 'Update',
      permission: 'update',
      icon: 'mdi mdi-pencil d-block font-size-12',
      color: 'success',
      fn: toggleCUModal,
      params: { mode: "Update", size: "lg", modeKey: 0 }
    },
    {
      label: 'Issue Bib',
      permission: 'bibIssue',
      icon: 'mdi mdi-numeric d-block font-size-12',
      color: 'info',
      fn: toggleCUModal,
      params: { mode: "Update", size: "md", modeKey: 1, absoluteHeader: true, header: 'Issue BIB' }
    },
    {
      label: 'Issue Tee',
      permission: 'teeIssue',
      icon: 'mdi mdi-tshirt-crew d-block font-size-12',
      color: 'info',
      fn: toggleConfirmModal,
      params: { request: teeIssueDataRequest, title: "Issue Below Tee?" }
    },
    {
      label: 'Set Bib Tag',
      permission: 'setBibTag',
      icon: 'mdi mdi-tag d-block font-size-12',
      color: 'secondary',
      fn: (params) => {
        setSelectedRaceKit(params.row);
        setBibTagModalVisible(true);
      },
      params: {},
    },
    {
      label: 'Set Goal',
      permission: 'setGoal',
      icon: 'mdi mdi-flag-checkered d-block font-size-12',
      color: 'secondary',
      fn: (params) => {
        setSelectedRaceKit(params.row);
        setGoalModalVisible(true);
      },
      params: {},
    },
    {
      label: 'View',
      permission: 'read',
      icon: 'mdi mdi-eye d-block font-size-12',
      color: 'primary',
      fn: toggleCUModal,
      params: { mode: "View", size: "lg" }
    },
    // eslint-disable-next-line
  ]), []);

  // eslint-disable-next-line
  const actions = useMemo(() => xsActions, [xsActions])
  
  // A remark only reaches the desk when it has been flagged — plain remarks stay
  // in the update form. Flagged ones are instructions for the moment of handover,
  // so they interrupt both issue flows.
  //
  // Except for anyone who can edit a kit: the flag exists to decide what
  // interrupts the desk, which is a distinction the people writing the notes do
  // not need applied to themselves, so they see every note.
  const canUpdateKits = HasPermission("update")
  const highlightedRemark = (row) => (row.remarks && (row.highlight_remarks || canUpdateKits)) ? row.remarks : null

  const remarkBanner = (row, className='') => {
    const remark = highlightedRemark(row)
    if(! remark) return null
    return (
      <div className={"alert alert-danger d-flex align-items-start mb-0 " + className} role="alert">
        <i className="mdi mdi-alert-circle-outline font-size-18 me-2"></i>
        <div>
          <div className="fw-bold">Note</div>
          {remark}
        </div>
      </div>
    )
  }

  const renderActions = (row, xs=false, actionList=false) => <ActionButtons key={row.id} actions={(actionList ? actionList : actions).filter(i=>(i.label !== "Issue Bib" || row.status === 'PENDING') && (i.label !== "Reset" || row.status !== "PENDING") && (i.label !=="Issue Tee" || row.status === 'BIB ISSUED')).map(a=>a.label === "Issue Tee" ? {...a, params: { ...a.params,
    body: <span>
      {remarkBanner(row, 'mt-1 mb-3')}
      <b>Name: </b>{row.name}<br/>
      <b>BIB No: </b>{row.bib_number}<br/>
      {row.race_tees && row.race_tees.length > 0 ? (
        row.race_tees.map((raceTee, index) => (
          <span key={index}>
            {index > 0 && <br/>}
            ({raceTee.quantity}x) {raceTee.tee?.display_name || 'Unknown Tee'}
            {raceTee.is_parent ? <Badge color="warning" className="bg-warning ms-1">PARENT</Badge> : null}
          </span>
        ))
      ) : (
        'No tees assigned'
      )}
    </span> 
  }} : (a.label === "Issue Bib" ? {...a, params: {...a.params, preBody: remarkBanner(row, 'rounded-0'), header: <span>Issue BIB - <span className='bibHighlight'>{row.bib_number}</span>{row.parent_bib ? <Badge color="warning" className="bg-warning ms-2 font-size-12">2 BIBS &mdash; incl. parent</Badge> : null}{highlightedRemark(row) ? <Badge color="danger" className="bg-danger ms-2 font-size-12">NOTE</Badge> : null}</span>}} : a))} type={xs ? xsActionListType : actionListType} row={row} xs={xs} />
  
  const valueGetter = (data, input) => {
    let d = get(data, getFN(input))
    if(input.id === "RKN"){
      return d + (data.club ? ` (${data.club})` : "")
    }
    if(input.type === 'checkbox'){
      return (parseInt(d) === 1 || d === true) ? "Yes" : ((parseInt(d) === 0 || d === false) ? "No" : "")	
    } else if(input.type === 'switch'){
      return (parseInt(d) === 1 || d === true) ? (input.list && input.list[0] ? input.list[0] : "Yes") : ((parseInt(d) === 0 || d === false) ? (input.list && input.list[1] ? input.list[1] : "No") : "")
    } else if((input.type === 'select' || input.type === 'multiselect' || input.type === 'nestedselect') && !input.rootValue){
      return d ? d[input.subFields?.label || "name"] : ""
    } else if(input.type === 'datepicker' && input.table?.dateFormat){
      return d ? moment(d).format(input.table.dateFormat) : null
    } else {
      return d
    }
  }

  const cellEditor = (type) => {
    switch(type){
      case 'checkbox':
        return 'CheckboxEditor'
      case 'switch':
        return 'SwitchEditor'
      case 'datepicker':
        return 'DateTimeEditor'
      case 'select':
        return 'SelectEditor'
      case 'multiselect':
        return 'SelectEditor'
      case 'mask':
        return 'MaskEditor'
      case 'radio':
        return 'RadioEditor'
      default:
        return 'DefaultEditor'
    }
  }

  // Default Selected Values as of now are set in Cell Editors by searching via label displayed on table
  let columns = useMemo(() => {
    return [...dataStructure.filter((val) => val.order?.table).sort((a,b)=>(a.order?.table > b.order?.table ? 1 : -1)).map((val) => (
        {
          headerName: val.tableHeader || val.label, 
          field: ((val.field || val.label.replace(/ /g, '_').toLowerCase()).replace(/\./g, '') + (val.subFields || (val.type === "select" && !val.rootValue) ? val.subFields?.label || val.subFields?.name || "name" : "" )).replace(/\./g, ''),
          filter: val.type === 'number' ? 'agNumberColumnFilter' : (val.type === 'datepicker' ? 'agDateColumnFilter' : 'agTextColumnFilter'),
          editable: val.table?.editable || false,
          cellEditor: cellEditor(val.type),
          cellEditorPopup: val.type === 'checkbox' || val.type === 'select' || val.type === 'multiselect' || val.type === 'radio',
          valueGetter: (params) => valueGetter(params?.data || params, val),
          cellRendererFramework: (params) => val.table?.customRender ? val.table.customRender(valueGetter(params?.data || params, val), params) : valueGetter(params?.data || params, val),
          cellEditorParams: (params) => ({
            fieldName: getFN(val),
            values: val.type === 'datepicker' ? {
                options: val.table?.options,
                value: params.data[getFN(val)]
              } : val.type === 'select' || val.type === 'multiselect' || val.type === 'radio' ? {
                list: val.list,
                getRequest: val.getRequest,
                creatable: ((val.type === 'select' || val.type === 'multiselect') && val.table?.creatable) || false,
                type: val.type,
                rootValue: val.rootValue,
                subFields: val.subFields,
              } : val.type === 'mask' ? {
                mask: val.table?.mask
              } : val.type === 'switch' ? {
                list: val.list,
              } : {
                type: val.type
              }
            
          }),
          maxWidth: val.table?.maxWidth || null,
          minWidth: val.table?.minWidth || null,
        }
      )),
      actionListLocation === 'inline' && !(breakPoint === 'xs' || breakPoint === 'sm') ? ({
        headerName: "Actions",
        cellRendererFramework: (params) => renderActions(params?.data || params),
        maxWidth: 200
      }) : null
      
    ].filter(i=>i!==null)
    // eslint-disable-next-line
  }, [dataStructure])

  useEffect(() => {
    if(gridApi){
      gridApi.sizeColumnsToFit()
    }
    // eslint-disable-next-line
  }, [columns])

  const activeFilterCount = countActiveRaceKitFilters(kitFilters)

  // Tee sizes are offered from what the event actually holds rather than the
  // whole catalogue, ordered by tee_size_id since size names do not sort.
  const teeSizeOptions = useMemo(() => {
    const bySize = new Map()
    ;(dataList || []).forEach((kit) => {
      (kit.race_tees || []).forEach((raceTee) => {
        const id = raceTee.tee?.tee_size_id
        const displayName = raceTee.tee?.display_name
        if(id === null || id === undefined || ! displayName) return
        const parts = displayName.split(' | ')
        bySize.set(id, { value: id, label: parts.length > 1 ? parts[1] : displayName })
      })
    })
    return Array.from(bySize.values()).sort((a, b) => a.value - b.value)
  }, [dataList])

  const data = dataList?.filter((row) => raceKitMatchesFilters(row, kitFilters)).map((row) => {
    let tempRow = cloneDeep(row)
    dataStructure.filter((input) => input.order?.table).forEach((input) => {
      const field = input.subFields || (input.type === "select" && !input.rootValue) ? (input.subFields?.label || input.subFields?.name || input.type === "select" ? ((input.field || input.label.replace(/ /g, '_').toLowerCase()) + "." + (input.subFields?.label || input.subFields?.name || "name")) : (input.field || input.label.replace(/ /g, '_').toLowerCase())) : (input.field || input.label.replace(/ /g, '_').toLowerCase());
      let temp = get(tempRow,field)
      if(! (temp === false || temp === 0)){
        temp = temp || input.tableDefault || ""
      }
      set(tempRow, field.replace(/\./g, ''), temp)
    })
    return tempRow
  })

  const changeFilter = (e,k) => {
    if(filters[k].type === "dateRange" && e.split(" to ").length > 1){
      setFilters(filters.map((f,key)=>{
        return key !== k ? f : {...f, value: e.split(" to ")}
      }))
    } else if(filters[k].type === "date"){
      setFilters(filters.map((f,key)=>{
        return key !== k ? f : {...f, value: e}
      }))
    } else if(filters[k].type === "select"){
      setFilters(filters.map((f,key)=>{
        return key !== k ? f : {...f, value: f.list.filter((o)=>(parseInt(o.value) === parseInt(e.value) || o.value === e.value))[0]}
      }))
    }
  }
  
  // specify the data
  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    if(params.api){
      params.api.sizeColumnsToFit();
      window.addEventListener('resize', function () {
        setTimeout(function () {
          params.api.sizeColumnsToFit();
        });
      });
      params.api.sizeColumnsToFit();
    }
  };

  useEffect(() => {	
    if(! ovf){	
      setXsFData(data.filter(item=>{	
        let match = true	
        if(mobileSearchFilter.length > 0){	
          let filters = mobileSearchFilter.split(" ")	
          filters.filter(f=>f.length > 0).forEach(filter=>{	
            let innerMatch = false	
            columns.forEach((column)=>{	
              if(String(column.valueGetter(item)).toLowerCase().indexOf(String(filter).toLowerCase()) >= 0){	
                innerMatch = true	
              }	
            })	
            if(! innerMatch){	
              match = false	
            }	
          })	
        }	
        return match	
      }))	
    } else {	
      setXsFData(data)	
    }	
    // eslint-disable-next-line
  }, [dataList, mobileSearchFilter, kitFilters])
  useEffect(() => {	
    // if(! ovf){	
      setSearchValue(mobileSearchFilter)	
    // }	
    // eslint-disable-next-line
  }, [mobileSearchFilter])

  useEffect(()=>{
    let maxPages = Math.ceil(xsFData.length / xsPageSize)
    if(maxPages !== xsMaxPage){
      setXsCurrentPage(1)
    }
    setXsMaxPage(maxPages)
    // eslint-disable-next-line
  }, [xsFData])

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Loader loading={partialUpdating} transparent />
          <Row>
            <Col xs={12} md={12}>
              <h3>
                {models}{" "}
                  <div className="d-block d-md-none">
                    <br />
                  </div>
                  {HasPermission("create") ? (
                    <Button disabled={actionsDisabled} color='primary' className='ml-2 waves-effect waves-light' type='submit' onClick={() => toggleCUModal({ mode: "Create" })}>
                      <i className='mdi mdi-plus d-block font-size-12'></i>
                      <span className="ms-1">Create</span>
                    </Button>
                  ) : null}&nbsp;&nbsp;
                  {HasPermission("import") ? (
                    <Button disabled={actionsDisabled} color='warning' className='ml-2 waves-effect waves-light' type='submit' onClick={() => setImportModalVisible(true)}>
                      <i className='mdi mdi-upload d-block font-size-12'></i>
                      <span className="ms-1">Import</span>
                    </Button>
                  ) : null}&nbsp;&nbsp;
                  {HasPermission("export") ? (
                    <Button disabled={actionsDisabled} color='info' className='ml-2 waves-effect waves-light' type='submit' onClick={async() => {
                      setActionsDisabled(true)
                      // Exports what is on screen: same filters, applied again
                      // server-side so the sheet keeps its full column set.
                      await exportDataListRequest(raceKitFiltersToPayload(kitFilters))
                      setActionsDisabled(false)
                    }}>
                      <i className='mdi mdi-download d-block font-size-12'></i>
                      <span className="ms-1">Export</span>
                    </Button>
                  ) : null}&nbsp;&nbsp;
                  {/* Not permission-gated: anyone who can see this page answers
                      the same questions, and the same content is public anyway. */}
                  <Button
                    color='light'
                    className='ml-2 waves-effect waves-light'
                    type='button'
                    onClick={() => setFaqModalVisible(true)}
                    title="Quick answers to common runner questions for this event"
                  >
                    <i className='mdi mdi-help-circle-outline d-block font-size-12'></i>
                    <span className="ms-1">FAQ</span>
                  </Button>&nbsp;&nbsp;
                  {HasPermission("clubIssue") ? (
                    <Button 
                      disabled={actionsDisabled} 
                      color='success' 
                      className='ml-2 waves-effect waves-light' 
                      type='submit' 
                      onClick={toggleBulkIssueModal}
                      title="Issue all race kits and bibs for a specific club"
                    >
                      <i className='mdi mdi-package-variant-closed d-block font-size-12'></i>
                      <span className="ms-1">Bulk Issue</span>
                    </Button>
                  ) : null}
                </h3>
            </Col>
            <Col xs={12} md={12} align="right">
              {filters && filters.length > 0 ? (
                <Row>
                  {filters.map((filter, key)=>(
                    <Col key={key} xs={12} md={filter.size || 6} className={filter.offset ? `offset-md-${filter.offset}` : ''}>
                      <Row>
                      <Col className="d-none d-md-block mt-2" xs={12} md={3}>
                        <Label>{filter.label}</Label>
                      </Col>
                      <Col className="d-block d-md-none mt-2" xs={12} md={3} align="left">
                        <Label>{filter.label}</Label>
                      </Col>
                      <Col xs={12} md={9} align="left">
                      {filter.type === "date" ? (
                          <Flatpickr onChange={(_,e) => changeFilter(e,key)} placeholder="Select..." options={{ altInput: true, defaultDate: filter.value }} value={filter.value} className="form-control d-block" />
                        ) : null}
                        {filter.type === "dateRange" ? (
                          <Flatpickr onChange={(_,e) => changeFilter(e,key)} placeholder="Select..." options={{ mode:'range', altInput: true, defaultDate: filter.value }} value={filter.value} className="form-control d-block" />
                        ) : null}
                        {filter.type === "select" ? (
                          <Select onChange={(e) => changeFilter(e,key)} placeholder="Select..." options={filter.list} value={filter.value} />
                        ) : null}
                      </Col></Row>
                    </Col>
                  ))}
                </Row>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              {!(breakPoint === 'xs' || breakPoint === 'sm') ? (
                <Card className='d-none d-md-block'>
                  <CardBody>
                    <Loader loading={tableLoading} />
                    <Row>
                      <Col xs={6}>
                        <div style={{display: 'flex', justifyContent: 'left'}}>	
                          <input value={searchValue} onKeyPress={(e)=>{	
                            if(e.key === 'Enter' && ovf){	
                              setLastAPIActionTime(new Date())	
                            }	
                          }} type="text" className="form-control" onChange={(e)=>{	
                            if(!ovf){	
                              gridApi.setQuickFilter(e.target.value);	
                              setGridApi(gridApi)	
                            }	
                            setSearchValue(e.target.value)	
                          }} placeholder="Search..." style={{ maxWidth:"400px", marginBottom:"15px" }} />	
                          {ovf ? (
                            <>&nbsp;&nbsp;&nbsp;<Button style={{maxHeight:'38px'}} color='primary' className='btn-sm waves-effect waves-light' onClick={()=>setLastAPIActionTime(new Date())}>
                              <i className='mdi mdi-magnify d-block font-size-12'></i>
                              <span className="ms-1">Search All</span>
                            </Button></>
                          ) : null}
                          &nbsp;&nbsp;
                          <Button
                            style={{maxHeight:'38px'}}
                            color={activeFilterCount > 0 ? 'primary' : 'light'}
                            className='waves-effect waves-light'
                            onClick={() => {
                              // Clubs are fetched lazily, same as the bulk issue
                              // modal does, so the page load stays as it was.
                              if(clubsForActiveEvent.data.length === 0 && ! clubsForActiveEvent.loading){
                                fetchClubsForActiveEvent()
                              }
                              setFilterModalVisible(true)
                            }}
                            title={activeFilterCount > 0 ? `${activeFilterCount} filter${activeFilterCount === 1 ? '' : 's'} applied` : 'Filter race kits'}
                          >
                            <i className='mdi mdi-filter-variant font-size-14'></i>
                            {activeFilterCount > 0 ? (
                              <Badge color="light" className="bg-light text-dark ms-1">{activeFilterCount}</Badge>
                            ) : null}
                          </Button>
                          {activeFilterCount > 0 ? (
                            <>&nbsp;&nbsp;<Button
                              style={{maxHeight:'38px'}}
                              color='link'
                              className='p-0'
                              onClick={() => setKitFilters(raceKitFiltersDefault)}
                              title="Clear all filters"
                            >Clear</Button></>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div style={{display: 'flex', justifyContent: 'right'}}>
                          {selectedRow && actionListLocation !== 'inline' ? (
                            <React.Fragment>
                              {renderActions(selectedRow?.data)}
                              <Button disabled={actionsDisabled} color='info' className='btn-sm waves-effect waves-light' style={{marginLeft:'5px'}} type='submit' onClick={()=>{
                                if(gridApi.getSelectedNodes().length > 0){
                                  gridApi.getSelectedNodes()[0].setSelected(false)
                                }
                              }}>
                                <i className='mdi mdi-close d-block font-size-12'></i>
                                <span className="ms-1">Clear</span>
                              </Button>
                            </React.Fragment>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div className={themeType === 'dark' ? "ag-theme-alpine-dark" : "ag-theme-alpine"} style={{height: '660px'}}>
                        <AgGridReact
                            frameworkComponents={{
                              renderActions: renderActions,
                              SelectEditor: SelectEditor,
                              DefaultEditor: DefaultEditor,
                              MaskEditor: MaskEditor,
                              DateTimeEditor: DateTimeEditor,
                              RadioEditor: RadioEditor,
                              CheckboxEditor: CheckboxEditor,
                              SwitchEditor: SwitchEditor,
                            }}
                            // editType="fullRow"
                            onSelectionChanged={()=>{
                              setSelectedRow(gridApi.getSelectedNodes()[0] || false)
                            }}
                            enableCellTextSelection={true}
                            defaultColDef={defaultColDef}
                            onGridReady={onGridReady}
                            rowHeight={55}
                            rowStyle={{border: 'none'}}
                            animateRows={true}
                            pagination={true}
                            paginationPageSize={10}
                            rowData={data}
                            getRowNodeId={(data)=>data.id}
                            columnDefs={columns}
                            rowSelection="single"
                          >
                        </AgGridReact>
                    </div>
                  </CardBody>
                </Card>
              ) : (
                <div className="d-block d-md-none mt-2">
                  <Loader loading={tableLoading} />
                  <div className="d-block d-md-none" style={{display: 'flex', justifyContent: 'left'}}>	
                    <div style={{display: 'flex', justifyContent: 'left'}}>	
                      <input value={mobileSearchFilter} type="text" className="form-control" onKeyPress={(e)=>{	
                          if(e.key === 'Enter' && ovf){	
                            setLastAPIActionTime(new Date())	
                          }	
                        }} onChange={(e)=>{	
                          setMobileSearchFilter(e.target.value)	
                        }} placeholder="Search..." style={{ maxWidth:"315px", marginBottom:"15px" }} />	
                        {ovf ? (	
                          <>&nbsp;&nbsp;&nbsp;<Button style={{maxHeight:'38px', minWidth:'58px'}} color='primary' className='btn-sm waves-effect waves-light' onClick={()=>setLastAPIActionTime(new Date())}>
                            <i className='mdi mdi-magnify d-block font-size-12'></i>
                            <span className="ms-1">Search</span>
                          </Button></>	
                        ) : null}	
                    </div>	
                  </div>
                  {xsFData.slice(((xsCurrentPage-1) * xsPageSize), (xsCurrentPage * xsPageSize)).map((item, key)=>(
                    <Card key={key} className={'border border-secondary'}>
                      <CardTitle className={"text-center bg-secondary pt-2 pb-2 text-white"}>{item[columns[0]?.field]}</CardTitle>
                        {remarkBanner(item, 'mx-2 mt-2 py-2')}
                        <CardBody className='pt-0 pb-0'>
                          {columns.map((column, ck) => (
                            ck > 0 ? <CardText key={ck} className="mb-2">{column.headerName !== "Status" ? <span style={{fontWeight:600}}>{column.headerName}: </span> : ""}<span className={themeType === 'dark' ? 'text-white' : 'text-primary'}>{
                              column.headerName === "Status" ? (<Badge title={(column.valueGetter(item))} color={(column.valueGetter(item))==="ISSUED" ? "success" : ((column.valueGetter(item)) === "BIB ISSUED" ? "warning" : "info")} className={"bg-"+((column.valueGetter(item))==="ISSUED" ? "success" : ((column.valueGetter(item)) === "BIB ISSUED" ? "warning" : "info"))+" font-size-14"} style={{padding: "5px 10px"}}>
                              {column.valueGetter(item)}
                          </Badge> ) : column.valueGetter(item)
                            }</span></CardText> : null
                          ))}
                        </CardBody>
                      <ButtonGroup>
                        {dataList.length > 0 ? renderActions(item, true, xsActions) : null}
                      </ButtonGroup>
                    </Card>
                  ))}
                  <ButtonGroup style={{display:"flex"}}>
                    <Button disabled={xsCurrentPage <= 1} onClick={()=>setXsCurrentPage(1)} color='secondary' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-double-left d-block font-size-16'></i>
                      <span className="ms-1">First</span>
                    </Button>
                    <Button disabled={xsCurrentPage <= 1} onClick={()=>setXsCurrentPage((c)=>--c)} color='secondary' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-left d-block font-size-16'></i>
                      <span className="ms-1">Prev</span>
                    </Button>
                    <Button color='secondary' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <Input style={{maxWidth:"50px"}} type="text" value={xsCurrentPage} onClick={(e)=>e.target.setSelectionRange(0, e.target.value.length)} onChange={(e)=>{
                        if(parseInt(e.target.value) > 0 && parseInt(e.target.value) <= xsMaxPage){
                          e.target.blur()
                          setXsCurrentPage(parseInt(e.target.value))
                        }
                      }} />
                    </Button>
                    <Button color='secondary' className='btn-md waves-effect waves-light'>
                      of
                    </Button>
                    <Button color='secondary' className='btn-md waves-effect waves-light'>
                      {xsMaxPage}
                    </Button>

                    <Button disabled={xsCurrentPage >= xsMaxPage} onClick={()=>setXsCurrentPage((c)=>++c)} color='secondary' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-right d-block font-size-16'></i>
                      <span className="ms-1">Next</span>
                    </Button>
                    <Button disabled={xsCurrentPage >= xsMaxPage} onClick={()=>setXsCurrentPage(xsMaxPage)} color='secondary' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-double-right d-block font-size-16'></i>
                      <span className="ms-1">Last</span>
                    </Button>
                  </ButtonGroup>
                </div>
              )}
            </Col>
          </Row>

          <DynamicModal config={cuModalConfig} toggleModal={toggleCUModal} submitModes={formModes} ds={dataStructure} />

          <ConfirmDialog id={confirmID} params={confirmParams} config={confirmConfig} visible={confirmModalVisible} toggleModal={toggleConfirmModal} />

          <ImportModal 
            isOpen={importModalVisible}
            toggle={() => setImportModalVisible(false)}
            onImport={importDataRequest}
            title="Import Race Kits"
          />

          <BibTagModal
            isOpen={bibTagModalVisible}
            toggle={() => setBibTagModalVisible(false)}
            raceKit={selectedRaceKit}
            onSuccess={() => {
              setSelectedRaceKit(null);
            }}
          />

          <GoalModal
            isOpen={goalModalVisible}
            toggle={() => setGoalModalVisible(false)}
            raceKit={selectedRaceKit}
            onSuccess={() => {
              setSelectedRaceKit(null);
            }}
          />

          <NoteModal />

          <RaceKitFilterModal
            isOpen={filterModalVisible}
            toggle={() => setFilterModalVisible(false)}
            filters={kitFilters}
            onApply={setKitFilters}
            raceOptions={raceKitRaces.data || []}
            clubOptions={(clubsForActiveEvent.data || []).map((club) => ({ label: club, value: club }))}
            clubsLoading={clubsForActiveEvent.loading}
            teeSizeOptions={teeSizeOptions}
            canSeeNotes={canUpdateKits}
          />

          <FaqModal
            isOpen={faqModalVisible}
            toggle={() => setFaqModalVisible(false)}
            loading={faq.loading}
            faq={faq.content}
            eventName={faq.eventName}
          />

          {/* Bulk Issue Modal */}
          <div className={`modal fade ${bulkIssueModal.visible ? 'show' : ''}`} 
               style={{ display: bulkIssueModal.visible ? 'block' : 'none' }}
               tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Bulk Issue Race Kits by Club</h5>
                  <button type="button" className="btn-close" onClick={toggleBulkIssueModal}></button>
                </div>
                <div className="modal-body">
                  <Row>
                    <Col xs={12}>
                      <div className="mb-3">
                        <Label>Club *</Label>
                        <div className="d-flex gap-2 align-items-end">
                          <div className="flex-grow-1">
                            <Select
                              placeholder="Select Club..."
                              options={clubsForActiveEvent.data.map(club => ({ label: club, value: club }))}
                              value={bulkIssueModal.selectedClub ? { label: bulkIssueModal.selectedClub, value: bulkIssueModal.selectedClub } : null}
                              onChange={(option) => setBulkIssueModal(prev => ({ ...prev, selectedClub: option ? option.value : null }))}
                              isLoading={clubsForActiveEvent.loading}
                              isDisabled={clubsForActiveEvent.loading}
                            />
                          </div>
                          {bulkIssueModal.selectedClub && (
                            <Button
                              color="info"
                              size="sm"
                              onClick={() => handleViewClubKits(bulkIssueModal.selectedClub)}
                              disabled={clubsForActiveEvent.loading}
                            >
                              <i className="mdi mdi-eye me-1"></i>
                              View Kits
                            </Button>
                          )}
                        </div>
                        {clubsForActiveEvent.error && <small className="text-danger">{clubsForActiveEvent.error}</small>}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>
                      <div className="mb-3">
                        <Label>Receiver Name *</Label>
                        <Input
                          type="text"
                          placeholder="Enter receiver name"
                          value={bulkIssueModal.receiverName}
                          onChange={(e) => setBulkIssueModal(prev => ({ ...prev, receiverName: e.target.value }))}
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={6}>
                      <div className="mb-3">
                        <Label>Receiver ID Number *</Label>
                        <Input
                          type="text"
                          placeholder="Enter receiver ID number"
                          value={bulkIssueModal.receiverIdNumber}
                          onChange={(e) => setBulkIssueModal(prev => ({ ...prev, receiverIdNumber: e.target.value }))}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>
                      <div className="mb-3">
                        <Label>Receiver Phone *</Label>
                        <Input
                          type="text"
                          placeholder="Enter receiver phone"
                          value={bulkIssueModal.receiverPhone}
                          onChange={(e) => setBulkIssueModal(prev => ({ ...prev, receiverPhone: e.target.value }))}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="alert alert-info">
                    <i className="mdi mdi-information-outline me-2"></i>
                    This will issue both BIB and TEE (if assigned) for all pending race kits in the selected club.
                  </div>
                  {clubsForActiveEvent.data.length === 0 && !clubsForActiveEvent.loading && (
                    <div className="alert alert-warning">
                      <i className="mdi mdi-alert-outline me-2"></i>
                      No clubs found with pending race kits for the active event.
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <Button color="secondary" onClick={toggleBulkIssueModal}>
                    Cancel
                  </Button>
                  <Button 
                    color="success" 
                    onClick={handleBulkIssue}
                    disabled={bulkIssueModal.loading || !bulkIssueModal.selectedClub || !bulkIssueModal.receiverName || !bulkIssueModal.receiverIdNumber || !bulkIssueModal.receiverPhone}
                  >
                    {bulkIssueModal.loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Processing...
                      </>
                    ) : (
                      'Issue All Race Kits'
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {bulkIssueModal.visible && <div className="modal-backdrop fade show"></div>}

          {/* View Club Kits Modal */}
          <div className={`modal fade ${viewClubKitsModal.visible ? 'show' : ''}`} 
               style={{ display: viewClubKitsModal.visible ? 'block' : 'none' }}
               tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Race Kits for Club: {viewClubKitsModal.selectedClub}</h5>
                  <div className="ms-auto d-flex align-items-center">
                    {HasPermission("export") && viewClubKitsModal.raceKits.length > 0 ? (
                      <Button
                        color="info"
                        size="sm"
                        className="me-3"
                        disabled={clubExportDisabled}
                        title="Download every kit for this club as an Excel sheet (ignores the search filter)"
                        onClick={async () => {
                          setClubExportDisabled(true)
                          await exportClubKitsRequest({ Club: viewClubKitsModal.selectedClub })
                          setClubExportDisabled(false)
                        }}
                      >
                        <i className="mdi mdi-download me-1"></i>
                        {clubExportDisabled ? 'Preparing...' : 'Download'}
                      </Button>
                    ) : null}
                    <button type="button" className="btn-close" onClick={toggleViewClubKitsModal}></button>
                  </div>
                </div>
                <div className="modal-body">
                  {viewClubKitsModal.loading ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading race kits...</p>
                    </div>
                  ) : viewClubKitsModal.error ? (
                    <div className="alert alert-danger">
                      <i className="mdi mdi-alert-circle me-2"></i>
                      {viewClubKitsModal.error}
                    </div>
                  ) : (
                    <div>
                      {/* Search Input */}
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="mdi mdi-magnify"></i>
                          </span>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Search by name, ID number, BIB number, email, phone, or race..."
                            value={viewClubKitsModal.searchQuery}
                            onChange={handleSearchChange}
                          />
                          {viewClubKitsModal.searchQuery && (
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={() => setViewClubKitsModal(prev => ({ ...prev, searchQuery: '' }))}
                            >
                              <i className="mdi mdi-close"></i>
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="alert alert-info mb-3">
                        <i className="mdi mdi-information-outline me-2"></i>
                        Found <strong>{filteredRaceKits.length}</strong> race kits for club <strong>"{viewClubKitsModal.selectedClub}"</strong>
                        {viewClubKitsModal.searchQuery && (
                          <span className="ms-2">
                            (filtered from {viewClubKitsModal.raceKits.length} total)
                          </span>
                        )}
                      </div>

                      {clubTeeSummary.rows.length > 0 && (
                        <div className="alert alert-light border mb-3">
                          <div className="d-flex align-items-center flex-wrap">
                            <strong className="me-3">
                              <i className="mdi mdi-tshirt-crew me-1"></i>Tees by size
                            </strong>
                            {clubTeeSummary.rows.map(row => (
                              <span key={row.size} className="me-3">
                                {row.size}: <Badge color="info" className="bg-info">{row.quantity}</Badge>
                              </span>
                            ))}
                            <span className="ms-auto">
                              Total: <Badge color="dark" className="bg-dark">{clubTeeSummary.total}</Badge>
                            </span>
                          </div>
                          {clubTeeSummary.issued > 0 && (
                            <div className="text-muted small mt-2">
                              <i className="mdi mdi-information-outline me-1"></i>
                              Includes {clubTeeSummary.issued} tee{clubTeeSummary.issued === 1 ? '' : 's'} already issued.
                            </div>
                          )}
                        </div>
                      )}

                      {filteredRaceKits.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover">
                            <thead className="table-light">
                              <tr>
                                <th>Name</th>
                                <th>ID Number</th>
                                <th>BIB Number</th>
                                <th>Race</th>
                                <th>Assigned Tees</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredRaceKits.map((raceKit, index) => (
                                <tr key={raceKit.id}>
                                  <td>
                                    <strong>{raceKit.name}</strong>
                                    {raceKit.email && (
                                      <div className="text-muted small">{raceKit.email}</div>
                                    )}
                                  </td>
                                  <td>{raceKit.id_number}</td>
                                  <td>
                                    <Badge color="primary" className="fs-6">
                                      {raceKit.bib_number}
                                    </Badge>
                                  </td>
                                  <td>{raceKit.race?.name || 'N/A'}</td>
                                  <td>
                                    {raceKit.race_tees && raceKit.race_tees.length > 0 ? (
                                      <div>
                                        {raceKit.race_tees.map((raceTee, teeIndex) => {
                                          const tee = raceTee.tee;
                                          const teeType = tee?.display_name;
                                          
                                          if (teeType) {
                                            return (
                                              <div key={teeIndex} className="mb-1">
                                                <Badge color="info" className="me-1">
                                                  {raceTee.quantity}x
                                                </Badge>
                                                {teeType.split(' | ').length > 1 ? teeType.split(' | ')[1] : teeType}
                                              </div>
                                            );
                                          } else {
                                            return (
                                              <div key={teeIndex} className="mb-1">
                                                <Badge color="info" className="me-1">
                                                  {raceTee.quantity}x
                                                </Badge>
                                                <span className="text-muted">Invalid tee data</span>
                                              </div>
                                            );
                                          }
                                        })}
                                      </div>
                                    ) : (
                                      <span className="text-muted">No tees assigned</span>
                                    )}
                                  </td>
                                  <td>
                                    <Badge 
                                      color={
                                        raceKit.status === 'ISSUED' ? 'success' : 
                                        raceKit.status === 'BIB ISSUED' ? 'warning' : 
                                        'info'
                                      }
                                    >
                                      {raceKit.status}
                                    </Badge>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : viewClubKitsModal.searchQuery ? (
                        <div className="text-center py-4">
                          <i className="mdi mdi-magnify text-muted" style={{ fontSize: '3rem' }}></i>
                          <h5 className="mt-3 text-muted">No race kits found</h5>
                          <p className="text-muted">No race kits match your search criteria.</p>
                          <Button 
                            color="outline-secondary" 
                            onClick={() => setViewClubKitsModal(prev => ({ ...prev, searchQuery: '' }))}
                          >
                            Clear Search
                          </Button>
                        </div>
                      ) : (
                        <div className="text-center py-4">
                          <i className="mdi mdi-information-outline text-muted" style={{ fontSize: '3rem' }}></i>
                          <h5 className="mt-3 text-muted">No race kits found</h5>
                          <p className="text-muted">This club doesn't have any race kits assigned.</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <Button color="secondary" onClick={toggleViewClubKitsModal}>
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {viewClubKitsModal.visible && <div className="modal-backdrop fade show"></div>}

          {/* SweetAlert Confirmation for Bulk Issue */}
          {showBulkIssueConfirm && (
            <SweetAlert
              warning
              showCancel
              confirmBtnText="Yes, Issue All Race Kits"
              cancelBtnText="Cancel"
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              title="Confirm Bulk Issue"
              onConfirm={handleBulkIssueConfirm}
              onCancel={() => setShowBulkIssueConfirm(false)}
            >
              <div className="text-start">
                <p>Are you sure you want to issue all pending race kits for club <strong>"{bulkIssueModal.selectedClub}"</strong>?</p>
                <p>This will issue both BIB and TEE (if available) for all pending race kits in this club.</p>
                <hr />
                <p><strong>Receiver Details:</strong></p>
                <ul className="list-unstyled">
                  <li><strong>Name:</strong> {bulkIssueModal.receiverName}</li>
                  <li><strong>ID:</strong> {bulkIssueModal.receiverIdNumber}</li>
                  <li><strong>Phone:</strong> {bulkIssueModal.receiverPhone}</li>
                </ul>
              </div>
            </SweetAlert>
          )}

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(RaceKits);
